export const FETCH_CATS = 'FETCH_CATS'
export const FETCH_PROMOTIONS = 'FETCH_PROMOTIONS'
export const FETCH_KEYWORDS = 'FETCH_KEYWORDS'


// WEBPACK FOOTER //
// ./src/actions/types.js